import { STORE_BADGE } from '../../components/storeBadgeAssets';

/**
 * CORE-1548 (QA 16.10.2026) — оба бейджа сторов в одну строку на любом телефоне.
 *
 * На Samsung S25 бейджи вставали столбиком: фиксированной высоты 44 хватало
 * на 360 CSS px, а при крупном масштабе экрана ширина окна меньше. Высота
 * теперь считается от ширины ряда: бейджи — официальные картинки, их
 * пропорции менять нельзя, значит подстраивается только высота.
 */
export const BADGE_GAP = 12;
/** Ниже бейдж перестаёт читаться — тогда ряду разрешено перенестись. */
export const BADGE_MIN_HEIGHT = 32;

const ASPECT_SUM = STORE_BADGE.ios.aspect + STORE_BADGE.android.aspect;

export function fitBadgeHeight(rowWidth: number, maxHeight: number): number {
  if (!(rowWidth > 0)) return maxHeight;
  const fits = Math.floor((rowWidth - BADGE_GAP) / ASPECT_SUM);
  return Math.max(BADGE_MIN_HEIGHT, Math.min(maxHeight, fits));
}

/**
 * CORE-1548 (QA george 31.10.2026, FAIL on dev 7f091e3) — a phone turned to landscape
 * (Pixel 7: 863×360) is wider than the tablet breakpoint, and the QR with «Наведите камеру
 * телефона…» appeared on it. The width decides the composition only; the code is for a
 * screen the phone can be pointed at. On a phone or a tablet (iOS / Android, iPadOS by its
 * touch) there is nothing to scan it with and the badge opens the store directly, so the
 * QR is off whatever the width.
 */
export function showsDownloadQr(o: { wide: boolean; mobileDevice: boolean }): boolean {
  return o.wide && !o.mobileDevice;
}
